var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ac_btns2"},[_c('span',{staticClass:"more_plus2"}),_c('ul',[_c('li',{staticClass:"top"},[_c('a',[_vm._v(_vm._s(_vm.commonl.up))])]),_c('li',{on:{"click":function($event){return _vm.BtnClick('write')}}},[_c('a',{staticClass:"agree"},[_vm._v(_vm._s(_vm.commonl.write))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }